import { Grid, Skeleton } from "@mui/material";
import { memo, useEffect, useState } from "react";
import ClickButton from "../../components/button/ClickButton";
import { useDispatch } from "react-redux";
import { callApiAction } from "../../store/actions/commonAction";
import { getLeadStatusCountApi } from "../../apis/lead.api";

const LeadCounts = ({ filters, setFilters }) => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);

  const fetchCountFun = () => {
    setLoading(true);
    dispatch(
      callApiAction(
        async () => await getLeadStatusCountApi({ ...filters }),
        (response) => {
          setData(response);
          setLoading(false);
        },
        (err) => {
          setLoading(false);
        }
      )
    );
  };
  useEffect(() => {
    fetchCountFun();
  }, [
    filters.startDate,
    filters.endDate,
    filters.hasDistributor,
    filters.userId,
  ]);

  if (loading)
    return (
      <Grid container spacing={2}>
        <Grid item xs={6} md={3}>
          <Skeleton variant="rounded" width="100%" height="100px" />
        </Grid>
        <Grid item xs={6} md={3}>
          <Skeleton variant="rounded" width="100%" height="100px" />
        </Grid>
        <Grid item xs={6} md={3}>
          <Skeleton variant="rounded" width="100%" height="100px" />
        </Grid>

        <Grid item xs={6} md={3}>
          <Skeleton variant="rounded" width="100%" height="90px" />
        </Grid>
      </Grid>
    );

  if (data.length > 0)
    return (
      <Grid container spacing={2}>
        {data.map((item) => (
          <Grid item key={item.parentStatus} xs={6} md={12 / data.length}>
            <ClickButton
              onClick={() =>
                setFilters({
                  ...filters,
                  parentStatus: item.parentStatus,
                  status: undefined,
                  pageNo: 1,
                })
              }
              active={filters.parentStatus == item.parentStatus}
              title={item.count}
              subTitle={item.title}
            />
          </Grid>
        ))}
      </Grid>
    );

  return <></>;
};

export default memo(LeadCounts);
